import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomNewsListComponent } from './custom-news-list.component';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule, ListNavigationModule, MediaModule, SpinnerModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [CustomNewsListComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ListNavigationModule,
    MediaModule,
    RouterModule,
    I18nModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NewsListComponent: {
          component: CustomNewsListComponent,
        },
      },
    } as CmsConfig),
    SpinnerModule,
    NgSelectModule,
    IconModule,
  ],
  exports: [CustomNewsListComponent],
})
export class CustomNewsListModule {}
